// ─── Role key constants ───────────────────────────────────────────────────────
export const ROLES = {
  HR_ADMIN:             'HR_ADMIN',
  OPERATIONAL_MANAGER:  'OPERATIONAL_MANAGER',
  GENERAL_MANAGER:      'GENERAL_MANAGER',
  AREA_MANAGER:         'AREA_MANAGER',
  EMPLOYEE:             'EMPLOYEE',
  SHIFT_LEAD:           'SHIFT_LEAD',
  MANAGER:              'MANAGER',   // legacy alias for OPERATIONAL_MANAGER
};

// ─── Role groups ──────────────────────────────────────────────────────────────

/** Roles that behave like a regular employee (onboarding, self-service only). */
export const EMPLOYEE_LIKE_ROLES = [ROLES.EMPLOYEE, ROLES.SHIFT_LEAD];

/** Roles that have manager-level access (excluding HR_ADMIN). */
export const MANAGER_ROLES = [
  ROLES.MANAGER,
  ROLES.OPERATIONAL_MANAGER,
  ROLES.GENERAL_MANAGER,
  ROLES.AREA_MANAGER,
];

/** All roles with elevated access (managers + HR Admin). */
export const ELEVATED_ROLES = [ROLES.HR_ADMIN, ...MANAGER_ROLES];

// ─── Display labels ───────────────────────────────────────────────────────────

/** Human-readable label for each role key. */
export const ROLE_LABELS = {
  [ROLES.HR_ADMIN]:            'HR Admin',
  [ROLES.OPERATIONAL_MANAGER]: 'Operational Manager',
  [ROLES.GENERAL_MANAGER]:     'General Manager',
  [ROLES.AREA_MANAGER]:        'Area Manager',
  [ROLES.EMPLOYEE]:            'Crew Member',
  [ROLES.SHIFT_LEAD]:          'Shift Lead',
  [ROLES.MANAGER]:             'Manager',
};

/** Returns the display label for a role, falling back to the raw key. */
export function getRoleLabel(role) {
  return ROLE_LABELS[role] ?? (role ? role.replace(/_/g, ' ') : '');
}

// ─── Role badge styles ────────────────────────────────────────────────────────

/**
 * Per-role label + Tailwind className used in role badges.
 * `color` is a Badge component variant (info/success/warning/neutral/etc.).
 */
export const ROLE_TAGS = {
  [ROLES.HR_ADMIN]:            { label: 'HR Admin',             className: 'bg-red-100 text-red-700',    color: 'danger'  },
  [ROLES.OPERATIONAL_MANAGER]: { label: 'Operational Manager',  className: 'bg-indigo-100 text-indigo-700', color: 'info' },
  [ROLES.GENERAL_MANAGER]:     { label: 'General Manager',      className: 'bg-amber-100 text-amber-700',  color: 'warning' },
  [ROLES.AREA_MANAGER]:        { label: 'Area Manager',         className: 'bg-violet-100 text-violet-700', color: 'success' },
  [ROLES.EMPLOYEE]:            { label: 'Crew Member',          className: 'bg-slate-100 text-slate-700',  color: 'neutral' },
  [ROLES.SHIFT_LEAD]:          { label: 'Shift Lead',           className: 'bg-slate-100 text-slate-700',  color: 'neutral' },
  [ROLES.MANAGER]:             { label: 'Operational Manager',  className: 'bg-indigo-100 text-indigo-700', color: 'info' },
};
